export class LicenseActivationError extends Error {
  constructor(public code: string) {
    super(`License activation failed with code: ${code}`);
  }
}
